import React, { useState, Suspense  } from "react";
import { LinearProgress } from "@mui/material";
import "./App.css";
import { ThemeProvider } from "@material-ui/core/styles";
import themelight from "../src/assets/themes/dds-material-react-light-theme";
import DeleteIcon from '@mui/icons-material/Delete';

import { Typography, Button } from "@material-ui/core";
import InfoIcon from '@mui/icons-material/Info';
import Grid from "@mui/material/Grid";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Snackbar, SnackbarContent } from "@material-ui/core";
import ContenedorDashboard from "./components/ContenedorDashboard";
import ContenedorHoras from "./components/ContenedorHoras";
import ProtectedRoute from "./components/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
// import ContenedorPerfil from "./components/ContenedorPerfil";
// import ContenedorPerfilCO from "./components/ContenedorPerfilCO";
// import ContenedorPerfilAdmin from "./components/ContenedorPerfilAdmin";
// import ContenedorValidar from "./components/ContenedorValidar";
// import ContenedorContrato from "./components/ContenedorContrato";

// import ContenedorContratoAsignado from "./components/ContenedorContratoAsignado";
// import ContenedorContratoDetalle from "./components/ContenedorContratoDetalle";
// import ContenedorGestionUsuario from "./components/ContenedorGestionUsuario";
// import ContenedorHorasIndividual from "./components/ContenedorHorasIndividual";
// import ContenedorCalendario from "./components/ContenedorCalendario";
// import ContenedorCalendarioCO from "./components/ContenedorCalendarioCO";
// import ContenedorHorasMasivas from "./components/ContenedorHorasMasivas";
// import ContenedorMantenedorHoras from "./components/ContenedorMantenedorHoras";
// import ContenedorMantenedorSernageomin from "./components/ContenedorMantenedorSernageomin";
// import ContenedorMantenedorUbicacion from "./components/ContenedorMantenedorUbicacion";
// import ContenedorMantenedorActividad from "./components/ContenedorMantenedorActividad";
// import ContenedorMantenedorOperaciones from "./components/ContenedorMantenedorOperaciones";
// import ContenedorMantenedorCargaHorasBhp from './components/ContenedorMantenedorCargaHorasBhp';
// import ContenedorHorasMasivasTransacciones from "./components/ContenedorHorasMasivasTransacciones";
// import ContenedorUnidadOrganizacional from "./components/ContenedorUnidadOrganizacional";
// import ContenedorHistorialCargaHorasBhp from "./components/ContenedorHistorialCargaHorasBhp";
/* import ContenedorPerfil from "./components/ContenedorPerfil";
import ContenedorPerfilCO from "./components/ContenedorPerfilCO";
import ContenedorPerfilAdmin from "./components/ContenedorPerfilAdmin";
import ContenedorValidar from "./components/ContenedorValidar";
import ContenedorContrato from "./components/ContenedorContrato";
import ContenedorContratoAsignado from "./components/ContenedorContratoAsignado";
import ContenedorContratoDetalle from "./components/ContenedorContratoDetalle";
import ContenedorGestionUsuario from "./components/ContenedorGestionUsuario";
import ContenedorHorasIndividual from "./components/ContenedorHorasIndividual";
import ContenedorCalendario from "./components/ContenedorCalendario";
import ContenedorCalendarioCO from "./components/ContenedorCalendarioCO";
import ContenedorHorasMasivas from "./components/ContenedorHorasMasivas";
import ContenedorMantenedorHoras from "./components/ContenedorMantenedorHoras";
import ContenedorMantenedorSernageomin from "./components/ContenedorMantenedorSernageomin";
import ContenedorMantenedorUbicacion from "./components/ContenedorMantenedorUbicacion";
import ContenedorMantenedorActividad from "./components/ContenedorMantenedorActividad";
import ContenedorMantenedorOperaciones from "./components/ContenedorMantenedorOperaciones";
import ContenedorMantenedorCargaHorasBhp from './components/ContenedorMantenedorCargaHorasBhp';
import ContenedorHorasMasivasTransacciones from "./components/ContenedorHorasMasivasTransacciones";
import ContenedorUnidadOrganizacional from "./components/ContenedorUnidadOrganizacional";
import ContenedorHistorialCargaHorasBhp from "./components/ContenedorHistorialCargaHorasBhp";
import ContenedorListadoAdministradores from "./components/ContenedorListadoAdministradores";
>>>>>>> front-gestion-admin */
import Login from "./pages/Login";
import { IdTokenClaims } from "./components/Login/CajaLogin";
import { useStateValue } from "./contexto/store";

// Import de Microsoft Azure AD
import { MsalProvider, useMsal } from "@azure/msal-react";
import ContenedorVistaCentroCosto_UOrg from "./components/ContenedorVistaCentroCosto_UOrg";
//import ContenedorDescargaRegistros from "./components/ContenedorDescargaRegistros";


const ContenedorContrato = React.lazy(() => import('./components/ContenedorContrato'));
const ContenedorPerfil = React.lazy(() => import('./components/ContenedorPerfil'));
const ContenedorPerfilCO = React.lazy(() => import('./components/ContenedorPerfilCO'));
const ContenedorPerfilAdmin = React.lazy(() => import('./components/ContenedorPerfilAdmin'));
const ContenedorValidar = React.lazy(() => import('./components/ContenedorValidar'));
const ContenedorContratoAsignado = React.lazy(() => import('./components/ContenedorContratoAsignado'));
const ContenedorContratoDetalle = React.lazy(() => import('./components/ContenedorContratoDetalle'));
const ContenedorGestionUsuario = React.lazy(() => import('./components/ContenedorGestionUsuario'));
const ContenedorHorasIndividual = React.lazy(() => import('./components/ContenedorHorasIndividual'));
const ContenedorCalendario = React.lazy(() => import('./components/ContenedorCalendario'));
const ContenedorCalendarioCO = React.lazy(() => import('./components/ContenedorCalendarioCO'));
const ContenedorHorasMasivas = React.lazy(() => import('./components/ContenedorHorasMasivas'));
const ContenedorMantenedorHoras = React.lazy(() => import('./components/ContenedorMantenedorHoras'));
const ContenedorMantenedorSernageomin = React.lazy(() => import('./components/ContenedorMantenedorSernageomin'));
const ContenedorMantenedorUbicacion = React.lazy(() => import('./components/ContenedorMantenedorUbicacion'));
const ContenedorMantenedorActividad = React.lazy(() => import('./components/ContenedorMantenedorActividad'));
const ContenedorMantenedorOperaciones = React.lazy(() => import('./components/ContenedorMantenedorOperaciones'));
const ContenedorMantenedorCargaHorasBhp = React.lazy(() => import('./components/ContenedorMantenedorCargaHorasBhp'));
const ContenedorHorasMasivasTransacciones = React.lazy(() => import('./components/ContenedorHorasMasivasTransacciones'));
const ContenedorUnidadOrganizacional = React.lazy(() => import('./components/ContenedorUnidadOrganizacional'));
const ContenedorHistorialCargaHorasBhp = React.lazy(() => import('./components/ContenedorHistorialCargaHorasBhp'));
const ContenedorMantenedorPeriodo = React.lazy(() => import('./components/ContenedorMantenedorPeriodo'));
const ContenedorListadoAdministradores = React.lazy(() => import('./components/ContenedorListadoAdministradores'));
const ContenedorDescargaReportes = React.lazy(() => import('./components/ContenedorDescargaReportes'));
const ContenedorCambioEstadoHoras = React.lazy(() => import('./components/ContenedorCambioEstadoHoras'));
const ContenedorListadoSuperUsuarios = React.lazy(() => import('./components/ContenedorListadoSuperUsuarios'));
const ContenedorMantenedorReglasKL = React.lazy(() => import("./components/ContenedorMantenedorReglasKL"));

// const LazyContrato = React.lazy(() => import ('./components/ContenedorContrato'))
// Metodos de Azure

const IdTokenContent = () => {
  /**
   * useMsal is hook that returns the PublicClientApplication instance,
   * an array of all accounts currently signed in and an inProgress value
   * that tells you what msal is currently doing. For more, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
   */
  const { accounts } = useMsal();
  const [idTokenClaims, setIdTokenClaims] = useState(null);

  const GetIdTokenClaims = () => {
    setIdTokenClaims(accounts[0].idTokenClaims)
  }
}

/**
 * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
 * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
 * only render their children if a user is authenticated or unauthenticated, respectively. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */


/* const MainContent = () => (
      <div className="App">
          <AuthenticatedTemplate>
              <IdTokenContent />
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
              <h5 className="card-title"></h5>
              // Comentar Login si se utiliza esta funcion
              <Login /> 
          </UnauthenticatedTemplate>
      </div>
); */

/**
 * msal-react is built on the React context API and all parts of your app that require authentication must be
 * wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication
 * then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the
 * PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */

const App = ({msalInstance}) => {
  
  // const LoginCopia = React.lazy(
  //   () => import("./")
  // )
  const [{ openSnackbar }, dispatch] = useStateValue();

  return (
    <MsalProvider instance={msalInstance}>
      <React.Fragment>
        <Snackbar
      bodyStyle={{ height: 400, width: 400, flexGrow: 0, backgroundColor: "#f77f00" }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={openSnackbar ? openSnackbar.open : false}
          autoHideDuration={3000}
          ContentProps={{ "aria-describedby": "message-id" }}
          
          onClose={() =>
            dispatch({
              type: "OPEN_SNACKBAR",
              openMensaje: {
                open: false,
                mensaje: "",
              },
            })
          }
        >
        
        <SnackbarContent style={{
            backgroundColor:'#f77f00',
              color: "black",
            fontSize: 12
            }}
          message={<Button size="big" id="client-snackbar">{openSnackbar ? openSnackbar.mensaje : ""}</Button>}
          />
          {/* <SnackbarContent style={{
      backgroundColor:'teal',
    }}
    message={<span id="client-snackbar">Hello World</span>}
  /> */}
        </Snackbar>
        <Suspense fallback={<LinearProgress />}>
          <Router>
            <ThemeProvider theme={themelight}>

              <Routes>
                {/* <Route exact path="/" element={<Login />} /> */}
                <Route exact path="/" element={<Login />} />
                <Route exact path="/auth/unauthorized" element={<Unauthorized />} />
                <Route
                  exact
                  path="/auth/contenedor"
                  element={<ProtectedRoute><ContenedorDashboard /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos"
                  element={<ProtectedRoute><ContenedorContrato /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos/registrarhrspersona/:id"
                  element={<ProtectedRoute><ContenedorHoras /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos/registrarhrspersona/cargaindividual/:id"
                  element={<ProtectedRoute><ContenedorHorasIndividual /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos/registrarhrspersona/cargaindividual/calendario/:id/:idContrato"
                  element={<ProtectedRoute><ContenedorCalendario /></ProtectedRoute>}
                />
                {/* Rutas Contract Owner */}
                <Route
                  exact
                  path="/auth/perfilco"
                  element={<ProtectedRoute><ContenedorPerfilCO /></ProtectedRoute>}
                />
                {/* Rutas Administrador */}
                <Route
                  exact
                  path="/auth/perfilAdmin"
                  element={<ProtectedRoute><ContenedorPerfilAdmin /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos-asignados"
                  element={<ProtectedRoute><ContenedorContratoAsignado /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos-asignados/detallecontrato/:id"
                  element={<ProtectedRoute><ContenedorContratoDetalle /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos-asignados/detallecontrato/calendario/:id/:idContrato"
                  element={<ProtectedRoute><ContenedorCalendarioCO /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/gestion-usuarios"
                  element={<ProtectedRoute><ContenedorGestionUsuario /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/contratos/registrarhrspersona/cargamasiva/:id"
                  element={<ProtectedRoute><ContenedorHorasMasivas /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/mantenedorhoras"
                  element={<ProtectedRoute><ContenedorMantenedorHoras /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/mantenedores/mantenedorsernageomin"
                  element={<ProtectedRoute><ContenedorMantenedorSernageomin /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/mantenedores/mantenedorubicacion"
                  element={<ProtectedRoute><ContenedorMantenedorUbicacion /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/mantenedores/mantenedoractividad"
                  element={<ProtectedRoute><ContenedorMantenedorActividad /></ProtectedRoute>}
                />
                <Route
                  exact
                  path="/auth/mantenedores/operaciones"
                  element={<ProtectedRoute><ContenedorMantenedorOperaciones /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="/auth/mantenedores/unidadorganizacional"
                  element={<ProtectedRoute><ContenedorUnidadOrganizacional /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="/auth/cargahorasbhp"
                  element={<ProtectedRoute><ContenedorMantenedorCargaHorasBhp /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="/auth/mantenedores/mantenedorreglasKL"
                  element={<ProtectedRoute><ContenedorMantenedorReglasKL /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="/auth/historialcargahorasbhp"
                  element={<ProtectedRoute><ContenedorHistorialCargaHorasBhp /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="auth/cargamasiva/transacciones"
                  element={<ProtectedRoute><ContenedorHorasMasivasTransacciones /></ProtectedRoute>}
                />
                {/*  Menu Listado de Administradores */}
                <Route
                  exact
                  path="auth/listadoAdministradores"
                  element={<ProtectedRoute><ContenedorListadoAdministradores /></ProtectedRoute>}
                />
                {/*  Menu Listado de Super Usuarios */}
                <Route
                  exact
                  path="auth/listadoSuperUsuarios"
                  element={<ProtectedRoute><ContenedorListadoSuperUsuarios /></ProtectedRoute>}
                />
                {/*  Menu Vista Centro de costo y Unidad Organizacional */}
                <Route
                  exact
                  path="auth/vistacentrocosto_unidadOrganizacional"
                  element={<ProtectedRoute><ContenedorVistaCentroCosto_UOrg /></ProtectedRoute>}
                />
                {/*  Menu Vista Mantenedor Periodo */}
                <Route
                  exact
                  path="auth/mantenendor_periodo"
                  element={<ProtectedRoute><ContenedorMantenedorPeriodo /></ProtectedRoute>}
                />

                <Route
                  exact
                  path="auth/descargareportes"
                  element={<ProtectedRoute><ContenedorDescargaReportes /></ProtectedRoute>}
                />

                {/* Fin Rutas Contract Owner */}

              <Route exact path="/auth/perfil" element={<ProtectedRoute><ContenedorPerfil /></ProtectedRoute>} />
              <Route exact path="/auth/ayuda" element={<ProtectedRoute><ContenedorValidar /></ProtectedRoute>} />
                <Route exact path="/auth/login" element={<Login />} />
              <Route exact path="/auth/cambio-estado-horas" element={<ProtectedRoute><ContenedorCambioEstadoHoras /></ProtectedRoute>}/>

                <Route exact path="" element={<Login />} />
              <Route exact path="*" element={<Typography variant="h1" style={{display: "flex",justifyContent: 'center', marginTop: '400px'}}>Not found</Typography>} />
              
              </Routes>

              {/* <Login /> */}
            </ThemeProvider>
          </Router>
        </Suspense>
      </React.Fragment>
    </MsalProvider>
)};

export default App;